import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { NewsItem, NewsItemValue } from '../models';

export const newsItemActions = createActionGroup({
    source: 'News Item',
    events: {
        'Get News Item': props<{ id: string }>(),
        'Get News Item Success': props<{ payload: NewsItem }>(),
        'Get News Item Error': props<{ code: number }>(),
        'Create News Item': props<{ value: NewsItemValue }>(),
        'Create News Item Success': props<{ payload: NewsItem }>(),
        'Create News Item Error': props<{ code: number }>(),
        'Update News Item': props<{ id: string; value: NewsItemValue }>(),
        'Update News Item Success': props<{ payload: NewsItem }>(),
        'Update News Item Error': props<{ code: number }>(),
        'Delete News Item': props<{ id: string }>(),
        'Delete News Item Success': props<{ id: string }>(),
        'Delete News Item Error': props<{ code: number }>(),
        Clear: emptyProps(),
    },
});
